import './ProviderRegistration.scss';
import { Link } from 'react-router-dom';
import GenericButton from '../common/button/GenericButton/GenericButton';
import { Col, Row, Form } from 'react-bootstrap';
import { Formik } from 'formik';

const UserProfileInformation = ({
  userInfoFormSchema,
  validateExistingUserInfo,
  userFormData,
  unserInfoHandleInput,
  approvalRequiredFlag,
}) => {
  return (
    <>
      <div className="provider-user-profile-info">
        <div className="review-yor-info pt-2">User profile information</div>
        <div className="mt-4">
          <Row className="ml-0">
            <Col md={12} className="p-0">
              <Formik
                validationSchema={userInfoFormSchema}
                initialValues={{
                  firstName: userFormData.firstName,
                  middleName: userFormData.middleName,
                  lastName: userFormData.lastName,
                  email: userFormData.email,
                  confirmEmail: userFormData.confirmEmail,
                  comments: userFormData.comments,
                }}
                onSubmit={(values) => {
                  validateExistingUserInfo(values);
                }}
              >
                {({
                  values,
                  touched,
                  errors,
                  status,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  setStatus,
                  setFieldValue,
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0 userinfo-formlabel">
                              First Name<sup className="text-danger">*</sup>{' '}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="firstName"
                              placeholder=""
                              className={
                                status && status.firstName ? 'is-invalid' : ''
                              }
                              value={values.firstName}
                              isInvalid={touched.firstName && errors.firstName}
                              onChange={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                              onBlur={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                            />
                            {status && status.firstName ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1 pt-2"
                              >
                                <span>{status.firstName}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.firstName && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {touched.firstName && errors.firstName}
                                  </span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0 userinfo-formlabel">
                              Middle Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="middleName"
                              placeholder=""
                              className={
                                status && status.middleName ? 'is-invalid' : ''
                              }
                              value={values.middleName}
                              isInvalid={
                                touched.middleName && errors.middleName
                              }
                              onChange={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                              onBlur={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                            />
                            {status && status.middleName ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1 pt-2"
                              >
                                <span>{status.middleName}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.middleName && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {touched.middleName && errors.middleName}
                                  </span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0 userinfo-formlabel">
                              Last Name<sup className="text-danger">*</sup>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="lastName"
                              placeholder=""
                              className={
                                status && status.lastName ? 'is-invalid' : ''
                              }
                              value={values.lastName}
                              isInvalid={touched.lastName && errors.lastName}
                              onChange={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                              onBlur={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                            />
                            {status && status.lastName ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1 pt-2"
                              >
                                <span>{status.lastName}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.lastName && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {touched.lastName && errors.lastName}
                                  </span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0 userinfo-formlabel">
                              Email<sup className="text-danger">*</sup>
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="email"
                              placeholder=""
                              className={
                                status && status.email ? 'is-invalid' : ''
                              }
                              value={values.email}
                              isInvalid={touched.email && errors.email}
                              onChange={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                              onBlur={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                            />
                            {status && status.email ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1 pt-2"
                              >
                                <span>{status.email}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.email && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{touched.email && errors.email}</span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="mb-4">
                            <Form.Label className="mb-0 userinfo-formlabel">
                              Confirm Email<sup className="text-danger">*</sup>
                            </Form.Label>
                            <Form.Control
                              type="email"
                              name="confirmEmail"
                              placeholder=""
                              className={
                                status && status.confirmEmail
                                  ? 'is-invalid'
                                  : ''
                              }
                              value={values.confirmEmail}
                              isInvalid={
                                touched.confirmEmail && errors.confirmEmail
                              }
                              onChange={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                              onBlur={(e) => {
                                unserInfoHandleInput(
                                  e,
                                  setFieldValue,
                                  handleChange,
                                );
                              }}
                            />
                            {status && status.confirmEmail ? (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1 pt-2"
                              >
                                <span>{status.confirmEmail}</span>
                              </Form.Control.Feedback>
                            ) : (
                              errors.confirmEmail && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>
                                    {touched.confirmEmail &&
                                      errors.confirmEmail}
                                  </span>
                                </Form.Control.Feedback>
                              )
                            )}
                          </Form.Group>
                        </Col>
                      </Row>
                      {approvalRequiredFlag && (
                        <Row>
                          <Col sm={6}>
                            <Form.Group className="mb-4">
                              <Form.Label className="mb-0 userinfo-formlabel">
                                Comments for approver
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="comments"
                                placeholder=""
                                className={
                                  status && status.comments ? 'is-invalid' : ''
                                }
                                value={values.comments}
                                isInvalid={touched.comments && errors.comments}
                                onChange={(e) => {
                                  unserInfoHandleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                                onBlur={(e) => {
                                  unserInfoHandleInput(
                                    e,
                                    setFieldValue,
                                    handleChange,
                                  );
                                }}
                              />
                              {status && status.comments ? (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="mt-1 pt-2"
                                >
                                  <span>{status.comments}</span>
                                </Form.Control.Feedback>
                              ) : (
                                errors.comments && (
                                  <Form.Control.Feedback
                                    type="invalid"
                                    className="mt-1 pt-2"
                                  >
                                    <span>
                                      {touched.comments && errors.comments}
                                    </span>
                                  </Form.Control.Feedback>
                                )
                              )}
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      <Row className="mt-3 d-flex">
                        <Col sm={3} className="already-registered ">
                          Already registered?
                          <Link to="/admin">Login here. </Link>
                        </Col>
                        <Col sm={3} className="text-right">
                          {' '}
                          <GenericButton className="ml-1" type="submit">
                            NEXT
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default UserProfileInformation;
